import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import ProjectManageStructureForm from './ProjectManageStructureForm'
import ProjectManageStructureView from './ProjectManageStructureView'
import scrollToComponent from 'react-scroll-to-component'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { useForm, Controller } from 'react-hook-form'
import {
  getDownload,
  getAttachments,
  getProjectManagementItem,
  saveProjectManagementByItem,
  updateProjectManagementByItem,
  deleteProjectManagementByItem,
} from '../../../redux/actions/projectManagement'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import WarningMessage from '../../../components/message/WarningMessage/WarningMessage'

export default function ProjectManageStructureWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleUpdateSave = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      let response
      if (request.id) {
        console.log('call update.')
        response = await updateProjectManagementByItem(id, request)
      } else {
        console.log('call save.')
        // console.log('call save.', JSON.stringify(request))
        response = await saveProjectManagementByItem(id, request)
      }
      console.log('response', response)

      if (response) {
        let form = formSchema
        form.role = response
        setIsError(false)
        setFormSchema(form)
        await dispatch(getSchemaSidebar(id))
        // const _schema = await getProjectManagementItem(id)
        // console.log('result', _schema)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async (id, schema) => {
    startLoading()
    setIsLoading(true)
    setIsDeleteError(false)
    try {
      console.log('call delete.')
      const status = await deleteProjectManagementByItem(id, schema.id)
      if (status === 200) {
        console.log('call get.')
        const _schema = await getProjectManagementItem(id)
        console.log('result', _schema)
        let form = formSchema
        form.role = _schema
        setFormSchema(form)
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('e', e)
      setIsDeleteError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleReloadAttachments = async () => {
    startLoading()
    setIsLoading(true)
    try {
      console.log('call getAttachments.')
      const response = await getAttachments(projectId)
      let _schema = formSchema
      _schema.attachFiles = response
      setFormSchema(_schema)
    } catch (e) {}
    setIsLoading(false)

    onChangeIsEdit(!isEdit)
    setIsError(false)
    setIsDeleteError(false)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })

    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)

    startLoading()
    var file = await getDownload(projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    var file = await getDownload(projectId, fileObj.id)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let datas = [...formSchema.role.value]

    let id
    if (data.selectedIndex != -1) {
      id = datas[data.selectedIndex].id
    }

    let request = {
      id: id,
      projectVersionId: projectId,
      roleCode: data.roleName,
      otherRoleName: data.otherRoleName,
      honorificCode: data.honorific,
      firstName: data.firstName,
      lastName: data.lastName,
      telephone: data.telephone,
      email: data.email,
    }

    handleUpdateSave(projectId, request)
  }

  const onDelete = (index) => {
    // console.log('handleDelete', index)
    let datas = [...formSchema.role.value]

    handleDelete(projectId, datas[index])
  }

  const ProjectManageFormEdit = (
    <ProjectManageStructureForm
      schema={formSchema}
      register={register}
      Controller={Controller}
      control={control}
      errors={errors}
      setValue={setValue}
      clearErrors={clearErrors}
      onSubmit={handleSubmit(onSubmit)}
      onDelete={onDelete}
      onDownload={onDownload}
      onPreview={onPreview}
      isError={isError}
      isDeleteError={isDeleteError}
      loading={isLoading}
    />
  )

  return (
    <div className="component-overview">
      <Panel
        bordered
        header={formSchema.header}
        eventKey={2}
        shaded
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        <WarningMessage message={formSchema?.feedbackBySubject} />

        {isEdit && showCommandButton ? (
          ProjectManageFormEdit
        ) : (
          <div>
            <ProjectManageStructureView
              onDownload={onDownload}
              onPreview={onPreview}
              schema={formSchema}
            />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />

            {isEdit ? (
              <div>
                <ViewButton icon="backward" onClick={handleReloadAttachments} disabled={isLoading}>
                  {'ดูรายการ' + (formSchema.buttonText ? formSchema.buttonText : '')}
                </ViewButton>
              </div>
            ) : (
              <EditButton
                onClick={() => {
                  onChangeIsEdit(!isEdit)
                  scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
                }}
                disabled={isLoading}
              >
                {'เพิ่ม/แก้ไข' + (formSchema.buttonText ? formSchema.buttonText : '')}
              </EditButton>
            )}
          </>
        )}
      </Panel>
    </div>
  )
}
